import React, { Component } from "react";
import { connect } from "react-redux";
import { isMobile } from 'react-device-detect';
import { Select, Input } from '../../ui';
import {
  setYatesValue,
  setClientValue
} from "../../../actions";
import Text from '../../Common/Form/Text';
import { yates } from "../../../operations";
import { Body } from '../../Common/Form';
import Continue from "../../Common/Continue";
import {
  validateEmail,
  arrayToSelectList,
  mapSelectList
} from "../../../helpers";

import iconUser from '../../../assets/icons/icon-user.svg';
import iconEmail from '../../../assets/icons/icon-email.svg';
import iconNumber from '../../../assets/icons/icon-number.svg';
import iconBoat from '../../../assets/icons/icon-embarcadiones-placer.svg';

class YateForm_1 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
    };

    this.continueCondition = this.continueCondition.bind(this);
    this.getClientContent = this.getClientContent.bind(this);
    this.getYateContent = this.getYateContent.bind(this);
  }

  componentDidMount() {
    this.checkContinueState(null);
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {

    const {
      name, email,
      nombre, marca,
      año, motorMarca
    } = this.props;

    return (
      name != '' &&
      email != '' &&
      validateEmail(email) &&
      nombre != '' &&
      marca != '' &&
      año != null &&
      motorMarca != null
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getClientContent() {

    const {
      name, email, showError,
      onClientValueChange
    } = this.props;

    return (
      <div className="Yates-formRow">
        <div style={{ flex: 1 }}>
          <Text style={{ paddingTop: '15px'}} className="Text-question">
            ¿Cómo te llamás?
          </Text>
          <Input
            id="name"
            name="name"
            maxLength="50"
            leftIcon={iconUser}
            value={name}
            showAlert={showError && !name}
            onChange={(event) => { onClientValueChange('name', event.target.value) }}
            //placeholder="ej. Juan Gonzáles"
            type="text"
          />
        </div>
        <div style={{ flex: 1 }}>
          <Text style={{ paddingTop: '15px'}} className="Text-question">
            ¿Cual es tu dirección de email?
          </Text>
          <Input
            id="email"
            name="email"
            maxLength="50"
            leftIcon={iconEmail}
            value={email}
            showAlert={showError && !validateEmail(email)}
            onChange={(event) => { onClientValueChange('email', event.target.value) }}
            //placeholder="ej. juangonzales@mail.com"
            type="email"
          />
        </div>
      </div>
    );
  }

  getYateContent() {

    const {
      nombre, año,
      años, marca,
      motorMarca, motores,
      showError, onValueChange
    } = this.props;

    return (
      <div className="Yates-formRow">
        <div style={{ flex: 1 }}>
          <Text style={{ paddingTop: '15px'}} className="Text-question">
            ¿Cuál es el nombre de la embarcación?
          </Text>
          <Input
            id="nombre"
            name="nombre"
            maxLength="50"
            leftIcon={iconBoat}
            value={nombre}
            showAlert={showError && !nombre}
            onChange={(event) => { onValueChange('nombre', event.target.value) }}
            //placeholder="ej. Usain Boat"
            type="text"
          />
          <Text style={{ paddingTop: '15px'}} className="Text-question">
            ¿En que año fue fabricado?
          </Text>
          <Select
            id="año"
            name="año"
            leftIcon={iconNumber}
            value={año}
            showAlert={showError && !año}
            onChange={(value) => { onValueChange('año', value) }}
            //placeholder="Seleccione un año"
            searchable={!isMobile}
            options={arrayToSelectList(años)}
            autoComplete="nope"
          />
        </div>
        <div style={{ flex: 1 }}>
          <Text style={{ paddingTop: '15px'}} className="Text-question">
            ¿Cuál es su clase/marca/modelo?
          </Text>
          <Input
            id="marca"
            name="marca"
            maxLength="50"
            leftIcon={iconBoat}
            value={marca}
            showAlert={showError && !marca}
            onChange={(event) => { onValueChange('marca', event.target.value) }}
            //placeholder="ej. Topaz"
            type="text"
          />
          <Text style={{ paddingTop: '15px'}} className="Text-question">
            ¿De qué marca es el motor?
          </Text>
          <Select
            id="motorMarca"
            name="motorMarca"
            leftIcon={iconBoat}
            value={motorMarca}
            showAlert={showError && !motorMarca}
            onChange={(value) => { onValueChange('motorMarca', value) }}
            //placeholder="Seleccione una marca"
            searchable={!isMobile}
            options={mapSelectList(motores)}
            autoComplete="nope"
          />
        </div>
      </div>
    );
  }

  render() {

    const { continue: toContinue } = this.state;

    return (
      <div>
        <Text style={{ paddingTop: '20px'}} className="Text-question Text-question--bold">
          Comencemos por saber de vos
        </Text>
        <Body columnContent={this.getClientContent} />
        <Text style={{ paddingTop: '20px'}} className="Text-question Text-question--bold">
          Contanos sobre tu Yate
        </Text>
        <Body columnContent={this.getYateContent} />
        <Continue state={toContinue} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    name: state.client.name,
    email: state.client.email,

    años: state.yates.años,
    motores: state.yates.motores,

    nombre: state.yates.nombre,
    marca: state.yates.marca,
    año: state.yates.año,
    motorMarca: state.yates.motorMarca,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onClientValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    onValueChange: (type, value) => {
      dispatch(setYatesValue(type, value));
    },
    getQuotation: () => {
      dispatch(yates.getQuotation());
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(YateForm_1);